"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runTest = runTest;
exports.deleteTest = deleteTest;
exports.addTest = addTest;
exports.setGenesysNo = setGenesysNo;
exports.replaceGenesysNo = replaceGenesysNo;
exports.showResult = showResult;
exports.setRunning = setRunning;
exports.setTestSystem = setTestSystem;
exports.toggleNodeChildren = toggleNodeChildren;
exports.setRunningSize = setRunningSize;
function runTest() {
    return {
        type: "nevada/RUN-TEST"
    };
}
function deleteTest(index) {
    return {
        type: "nevada/DELETE-TEST",
        index: index
    };
}
function addTest() {
    return {
        type: "nevada/ADD-TEST"
    };
}
function setGenesysNo(text, index) {
    return {
        type: "nevada/SET-GENESYS-NO",
        text: text,
        index: index
    };
}
function replaceGenesysNo(texts) {
    return {
        type: "nevada/REPLACE-GENESYS-NO",
        texts: texts
    };
}
function showResult(show, systemsToTest) {
    return {
        type: "nevada/SHOW-RESULT",
        show: show,
        systemsToTest: systemsToTest
    };
}
function setRunning(running) {
    return {
        type: "nevada/SET-RUNNING",
        running: running
    };
}
function setTestSystem(system) {
    return {
        type: "nevada/SET-TEST-SYSTEM",
        system: system
    };
}
function toggleNodeChildren(testId, path) {
    return {
        type: "nevada/toggle-node-children",
        testId: testId,
        path: path
    };
}
function setRunningSize(size) {
    return {
        type: "nevada/SET-RUNNING-SIZE",
        size: size
    };
}
//# sourceMappingURL=actions.js.map